import React from "react";
import Panel from "../../elements/Panel";
import getClassNameFactory from "../../utilities/classNames";
import classNames from "classnames";
import Item from "./components/Item";

var DataCallout = function DataCallout(_ref) {
  var _ref$borderAndBackgro = _ref.borderAndBackground,
      borderAndBackground = _ref$borderAndBackgro === void 0 ? false : _ref$borderAndBackgro,
      children = _ref.children,
      _ref$horizontalConten = _ref.horizontalContentAtDesktop,
      horizontalContentAtDesktop = _ref$horizontalConten === void 0 ? false : _ref$horizontalConten;
  var getClassName = getClassNameFactory(DataCallout.displayName);
  return /*#__PURE__*/React.createElement(Panel, {
    className: getClassName({
      componentName: "DataCalloutOverride"
    })
  }, /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      modifiers: classNames({
        borderAndBackground: borderAndBackground,
        horizontalContentAtDesktop: horizontalContentAtDesktop
      })
    })
  }, children));
};

DataCallout.displayName = "DataCallout";
DataCallout.Item = Item;
export default DataCallout;